import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import Header from './layout/Header';
import { ProspectionView, CrmView } from './views';
import { ActivityDrawer } from './activity/ActivityDrawer';
import { ChangelogPopup } from './changelog/ChangelogPopup';
import LoadingSpinner from './common/LoadingSpinner';
import { useAuth } from '../context/AuthContext';

const AppContainer = styled.div`
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  background-color: ${props => props.theme.colors.background};
  color: ${props => props.theme.colors.text};
  display: flex;
  flex-direction: column;
`;

const MainContent = styled.main`
  flex: 1;
  margin-top: 60px; /* Hauteur du header fixe par défaut */
  overflow: hidden;
  
  @media (max-width: 768px) {
    margin-top: 56px; /* Header plus petit sur mobile */
  }
  
  @media (max-width: 480px) {
    margin-top: 52px; /* Header encore plus petit sur très petits écrans */
  }
`;


/**
 * Composant principal de l'application avec le nouveau layout
 * Header fixe + contenu principal (Prospection/CRM)
 */
const MainAppContent: React.FC = () => {
  console.log('🏠 MainApp render avec nouveau layout');
  const [activeView, setActiveView] = useState<'prospection' | 'crm'>('prospection');
  const [isActivityDrawerOpen, setIsActivityDrawerOpen] = useState(false);
  const { shouldShowChangelog } = useAuth();

  const handleViewChange = useCallback((view: 'prospection' | 'crm') => {
    setActiveView(view);
    console.log('🔄 Changement de vue:', view);
  }, []);

  const handleActivityClick = useCallback(() => {
    setIsActivityDrawerOpen(true);
  }, []);

  const handleAddCategory = useCallback(() => {
    // Cette fonction peut être utilisée pour ajouter une catégorie depuis le header si nécessaire
    console.log('📁 Ajout de catégorie demandé');
  }, []);

  return (
    <AppContainer>
      <Header 
        activeView={activeView}
        onViewChange={handleViewChange}
        onActivityClick={handleActivityClick}
      />
      
      <MainContent>
        {activeView === 'prospection' ? (
          <ProspectionView onAddCategory={handleAddCategory} />
        ) : (
          <CrmView />
        )}
      </MainContent>
      
      <ActivityDrawer 
        isOpen={isActivityDrawerOpen} 
        onClose={() => setIsActivityDrawerOpen(false)} 
      />
      
      <ChangelogPopup 
        isOpen={shouldShowChangelog}
        onClose={() => {
          // La fermeture gère automatiquement la mise à jour via ChangelogService
        }}
      />
      
      <LoadingSpinner />
    </AppContainer>
  );
};

// Composant wrapper qui fournit le contexte de filtrage d'utilisateur
const MainApp: React.FC = () => {
  return <MainAppContent />;
};

export default MainApp;

